<template>
  <v-card class="ma-4" :width="cardWidth" id="missing-acc-report">
    <v-card-title class="pb-0" style="word-break: normal">
      <v-card-text class="text-h6 font-weight-medium text-uppercase pa-0">
        Missing Accessories Report
      </v-card-text>
    </v-card-title>
    <v-row :class="inputStyle">
      <v-col class="py-0">
        <v-menu
          v-model="startMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              filled
              dense
              v-model="data.start_date"
              label="Start Date"
              append-icon="mdi-calendar-blank"
              id="start-date"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="data.start_date"
            no-title
            @input="startMenu = false"
            id="start-date-picker"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col class="py-0">
        <v-menu
          v-model="endMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              filled
              dense
              v-model="data.end_date"
              label="End Date"
              id="end-date"
              append-icon="mdi-calendar-blank"
              v-on="on"
              :rules="[rules.afterStart]"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="data.end_date"
            no-title
            :min="data.start_date"
            @input="endMenu = false"
            id="end-date-picker"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <v-btn
          class="mx-4"
          style="width: calc(100% - 32px); font-size:12px;"
          color="secondary"
          id="export-missing-report-button"
          @click="_setExport(true)"
        >
          <v-icon>mdi-download</v-icon>
          Export Report
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import moment from 'moment';
import { mapMutations, mapGetters } from 'vuex';
import { MobileView } from '@/mixins';

export default {
  data() {
    return {
      startMenu: false,
      endMenu: false,
      rules: {
        afterStart: () => moment(this.data.start_date).isBefore(moment(this.data.end_date))
          || 'End date must be later than start date',
      },
    };
  },
  mixins: [MobileView],
  methods: {
    ...mapMutations({
      _setData: 'reconciliation/setData',
      _setExport: 'reconciliation/setExport',
    }),
  },
  computed: {
    ...mapGetters({
      _getData: 'reconciliation/getData',
    }),
    data: {
      get() {
        return this._getData;
      },
      set(val) {
        this._setData(val);
      },
    },
    inputStyle() {
      if (!this.showMobileView) {
        return 'mx-4 mt-4 d-flex flex-column';
      }
      return 'mx-4 mt-4';
    },
    cardWidth() {
      if (this.showMobileView) {
        return '92%';
      }
      return '30%';
    },
  },
};
</script>
